import { Portal, Root, Trigger } from '@radix-ui/react-popover'
import { SansText } from '../SansText/SansText'
import { StyledArrow, StyledContent, TextContent } from './Popover.styles'
import type { PopoverProps } from './Popover.types'

export const Popover = ({
  className = '',
  children,
  message,
  defaultOpen = false,
  side = 'bottom',
  avoidCollisions = true,
  collisionBoundary = [],
}: PopoverProps): JSX.Element => {
  return (
    <Root defaultOpen={defaultOpen}>
      <Trigger asChild>{children}</Trigger>
      <Portal>
        <StyledContent
          className={className}
          sideOffset={5}
          side={side}
          avoidCollisions={avoidCollisions}
          collisionBoundary={collisionBoundary}
          collisionPadding={30}
        >
          <TextContent>
            <SansText
              color="primary"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          </TextContent>
          <StyledArrow />
        </StyledContent>
      </Portal>
    </Root>
  )
}
